import {
  QConfigRandomConfigType,
  QConfigRandomGroupBy,
  type QConfigTaskMetadataRandomConfig,
} from '@exam-management/graphql';

import type { QConfigRandomType } from '../../types';

export function getRandomConfigType(
  config?: QConfigTaskMetadataRandomConfig | null,
): QConfigRandomType | null {
  if (!config) {
    return null;
  }

  if (config.type === QConfigRandomConfigType.Fixed) {
    return 'FIXED';
  }

  switch (config?.groupBy) {
    case QConfigRandomGroupBy.Part:
      return 'RANDOM_BY_PART';
    case QConfigRandomGroupBy.Hierarchy:
      return 'RANDOM_BY_HIERARCHY';
    default:
      return 'ALL_RANDOM';
  }
}
